import React from "react";
import {useIntl} from "react-intl";
import {Wallet as W, WalletModal as WModal} from "@housebets/housebets-x-package";

import {DepositCashForm, DepositCryptoForm, WithdrawCashForm, WithdrawCryptoForm} from "../../forms";
import {WalletType} from "app/types/common";
import {useGTMEvents} from "app/hooks/useGTMEvents";

import {useWalletModalData} from "./hooks/useWalletModalData";
import {DepositsPanel, WithdrawPanel} from "../../wallet";
import {useCryptoDropdownData} from "../../forms/CryptoDropdown/hooks/useCryptoDropdown";

export const WalletModal: React.FC = () => {
    const {walletType, closeWalletModal, activeTabIdx, setActiveTabIdx, activeItem, setActiveItem, fiatData, cryptoData, title} = useWalletModalData();
    const {$t} = useIntl();
    const {modal} = useGTMEvents();

    const {options} = useCryptoDropdownData();

    return (
        <WModal
            title={$t({id: "Deposit"})}
            isOpen={walletType !== WalletType.Hide}
            onClose={closeWalletModal}
            afterOpenModal={() => {
                modal.show("wallet");
            }}
            onAfterClose={() => {
                modal.close("wallet");
            }}>
            <W.MainWrapper title={title} onClose={closeWalletModal} navBack={() => setActiveItem(undefined)} showPrevButton={!!activeItem}>
                <W.WalletTabs
                    tabs={[
                        {
                            name: $t({id: "Deposit"}),
                        },
                        {
                            name: $t({id: "Withdraw"}),
                        },
                    ]}
                    activeTabIDX={activeTabIdx}
                    onTabChange={(v) => {
                        setActiveTabIdx(v);
                    }}
                    isCategorySelected={!!activeItem}
                    currentForm={
                        <>
                            {/* Deposit */}
                            {activeTabIdx === 0 && activeItem?.category === "crypto" && <DepositCryptoForm category={activeItem} onSubmit={() => {}} />}
                            {activeTabIdx === 0 && activeItem?.category === "cash" && <DepositCashForm category={activeItem} onSubmit={() => {}} />}
                            {/* Withdraw */}
                            {activeTabIdx === 1 && activeItem?.category === "crypto" && (
                                <WithdrawCryptoForm category={activeItem} options={options.filter((item) => item.name === "Crypto")[0].options} />
                            )}
                            {activeTabIdx === 1 && activeItem?.category === "cash" && (
                                <WithdrawCashForm
                                    category={activeItem}
                                    onSubmit={() => {}}
                                    // options={options.filter((item) => item.name === "Fiat")[0].options}
                                />
                            )}
                        </>
                    }
                    panels={[
                        <DepositsPanel
                            key="deposit"
                            setSelectedCategory={(value) => setActiveItem(value)}
                            fiatData={fiatData}
                            cryptoData={cryptoData}
                            selectedCategory={activeItem}
                        />,
                        <WithdrawPanel
                            key="withdraw"
                            setSelectedCategory={(value) => setActiveItem(value)}
                            fiatData={fiatData}
                            cryptoData={cryptoData}
                            selectedCategory={activeItem}
                        />,
                    ]}
                />
            </W.MainWrapper>
        </WModal>
    );
};

WalletModal.displayName = "WalletModal";
